// assets
import {
    IconDashboard,
    IconWallet,
    IconReceipt2,
    IconPackage,
    IconUsers,
    IconReportAnalytics,
    IconListCheck,
    IconLayoutGrid,
    IconHistory
} from '@tabler/icons';

// constant
const icons = {
    IconDashboard,
    IconWallet,
    IconReceipt2,
    IconPackage,
    IconUsers,
    IconReportAnalytics,
    IconListCheck,
    IconLayoutGrid,
    IconHistory
};

const prefix = '/vendor';

const overview = {
    id: 'overview',
    title: 'Business Overview',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Store Dashboard',
            type: 'item',
            url: `${prefix}`,
            icon: icons.IconDashboard,
            breadcrumbs: false,
            permission: 'view_analytics'
        },
        {
            id: 'reports-sales',
            title: 'Sales Reports',
            type: 'item',
            url: `${prefix}/reports/sales`,
            icon: icons.IconReportAnalytics,
            breadcrumbs: false,
            permission: 'view_analytics'
        }
    ]
};

const salesAndInventory = {
    id: 'sales-inventory',
    title: 'Shop Management',
    type: 'group',
    children: [
        {
            id: 'orders',
            title: 'Active Orders',
            type: 'item',
            url: prefix + '/orders',
            icon: icons.IconReceipt2,
            breadcrumbs: false,
            permission: 'manage_orders'
        },
        {
            id: 'inventory-mgt',
            title: 'Catalogue Mgt',
            type: 'collapse',
            icon: icons.IconPackage,
            children: [
                { id: 'products', title: 'Product List', type: 'item', url: prefix + '/products', permission: 'manage_inventory' },
                { id: 'categories', title: 'Product Tags', type: 'item', url: prefix + '/categories', permission: 'manage_inventory' }
            ]
        }
    ]
};

const financialGroup = {
    id: 'finances',
    title: 'Financials',
    type: 'group',
    children: [
        {
            id: 'money-mgt',
            title: 'Revenue & Payout',
            type: 'collapse',
            icon: icons.IconWallet,
            children: [
                { id: 'wallet', title: 'My Wallet', type: 'item', url: prefix + '/wallet', permission: 'manage_finance' },
                {
                    id: 'payouts',
                    title: 'Payout Requests',
                    type: 'item',
                    url: prefix + '/payouts',
                    icon: icons.IconListCheck,
                    permission: 'manage_finance'
                },
                {
                    id: 'transactions',
                    title: 'Statement',
                    type: 'item',
                    url: prefix + '/transactions',
                    icon: icons.IconHistory,
                    permission: 'manage_finance'
                }
            ]
        }
    ]
};

const teamManagement = {
    id: 'team-mgt',
    title: 'Personnel',
    type: 'group',
    children: [
        {
            id: 'staffs',
            title: 'Staff Directory',
            type: 'item',
            url: prefix + '/staffs',
            icon: icons.IconUsers,
            breadcrumbs: false,
            permission: 'manage_staff'
        }
    ]
};

const compliance = {
    id: 'compliance',
    title: 'Business Compliance',
    type: 'group',
    children: [
        {
            id: 'kyc',
            title: 'Store Verification',
            type: 'item',
            url: `${prefix}/kyc`,
            icon: icons.IconListCheck,
            breadcrumbs: false,
            permission: 'manage_inventory' // Using a common permission or a specific one if needed
        }
    ]
};

const vendorMenuItems = [overview, salesAndInventory, financialGroup, teamManagement, compliance];

export default vendorMenuItems;
